import { IPostFormInitialState } from '../../components/Feed/reducer/reducer';
import { FeeStructure, IEvent, IEventKind, ILocation, IEventState } from '../../types/global/helper';
import { Pagination } from '../activity/types';
import { ICheckoutItem } from '../checkout/types';

export const types = {
    GET_EVENTS: 'GET_EVENTS',
    GET_EVENTS_SUCCESS: 'GET_EVENTS_SUCCESS',
    GET_EVENTS_FAIL: 'GET_EVENTS_FAIL',

    GET_EVENT_DETAILS: 'GET_EVENT_DETAILS',
    GET_EVENT_DETAILS_SUCCESS: 'GET_EVENT_DETAILS_SUCCESS',
    GET_EVENT_DETAILS_FAIL: 'GET_EVENT_DETAILS_FAIL',

    CREATE_EVENT: 'CREATE_EVENT',
    CREATE_EVENT_SUCCESS: 'CREATE_EVENT_SUCCESS',
    CREATE_EVENT_FAIL: 'CREATE_EVENT_FAIL',

    UPDATE_EVENT: 'UPDATE_EVENT',
    UPDATE_EVENT_SUCCESS: 'UPDATE_EVENT_SUCCESS',
    UPDATE_EVENT_FAIL: 'UPDATE_EVENT_FAIL',

    DELETE_EVENT: 'DELETE_EVENT',
    DELETE_EVENT_SUCCESS: 'DELETE_EVENT_SUCCESS',
    DELETE_EVENT_FAIL: 'DELETE_EVENT_FAIL',

    PUBLISH_EVENT: 'PUBLISH_EVENT',
    PUBLISH_EVENT_SUCCESS: 'PUBLISH_EVENT_SUCCESS',
    PUBLISH_EVENT_FAIL: 'PUBLISH_EVENT_FAIL',

    UNPUBLISH_EVENT: 'UNPUBLISH_EVENT',
    UNPUBLISH_EVENT_SUCCESS: 'UNPUBLISH_EVENT_SUCCESS',
    UNPUBLISH_EVENT_FAIL: 'UNPUBLISH_EVENT_FAIL',

    PURCHASE_TICKET: 'PURCHASE_TICKET',
    PURCHASE_TICKET_SUCCESS: 'PURCHASE_TICKET_SUCCESS',
    PURCHASE_TICKET_FAIL: 'PURCHASE_TICKET_FAIL',

    APPROVE_EVENT: 'APPROVE_EVENT',
    APPROVE_EVENT_SUCCESS: 'APPROVE_EVENT_SUCCESS',
    APPROVE_EVENT_FAIL: 'APPROVE_EVENT_FAIL',

    GET_SIMILAR_EVENTS: 'GET_SIMILAR_EVENTS',
    GET_SIMILAR_EVENTS_SUCCESS: 'GET_SIMILAR_EVENTS_SUCCESS',
    GET_SIMILAR_EVENTS_FAIL: 'GET_SIMILAR_EVENTS_FAIL',

    FILTER_EVENTS: 'FILTER_EVENTS',
    FILTER_EVENTS_SUCCESS: 'FILTER_EVENTS_SUCCESS',
    FILTER_EVENTS_FAIL: 'FILTER_EVENTS_FAIL',

    SET_EVENT_FILTER: 'SET_EVENT_FILTER',

    GET_MANAGE_EVENT: 'GET_MANAGE_EVENT',
    GET_MANAGE_EVENT_SUCCESS: 'GET_MANAGE_EVENT_SUCCESS',
    GET_MANAGE_EVENT_FAIL: 'GET_MANAGE_EVENT_FAIL',
    CLEAR_MANAGE_EVENT_ERROR: 'CLEAR_MANAGE_EVENT_ERROR',

    CREATE_DISCOUNT_CODE: 'CREATE_DISCOUNT_CODE',
    CREATE_DISCOUNT_CODE_SUCCESS: 'CREATE_DISCOUNT_CODE_SUCCESS',
    CREATE_DISCOUNT_CODE_FAIL: 'CREATE_DISCOUNT_CODE_FAIL',

    UPDATE_DISCOUNT: 'UPDATE_DISCOUNT',
    UPDATE_DISCOUNT_SUCCESS: 'UPDATE_DISCOUNT_SUCCESS',
    UPDATE_DISCOUNT_FAIL: 'UPDATE_DISCOUNT_FAIL',

    DELETE_DISCOUNT: 'DELETE_DISCOUNT',
    DELETE_DISCOUNT_SUCCESS: 'DELETE_DISCOUNT_SUCCESS',
    DELETE_DISCOUNT_FAIL: 'DELETE_DISCOUNT_FAIL',

    CANCEL_EVENT: 'CANCEL_EVENT',
    CANCEL_EVENT_SUCCESS: 'CANCEL_EVENT_SUCCESS',
    CANCEL_EVENT_FAIL: 'CANCEL_EVENT_FAIL',
};

export interface IEventInitialState {
    events: IEvent[];
    similarEvents: IEvent[];
    eventDetails: IEvent | null;
    loading: boolean;
    error: string | null;
    success: boolean;
    message: string;
    selectedEvent?: IEvent;
    fetchingEvent?: boolean;
    purchasingTickets?: boolean;
    tickets?: any[];
    currentEventLimit?: number;
    currentEventPage?: number;
    totalResult?: number;
    canLoadMore?: boolean;
    limit?: number;
    errMsg?: any;
    eventsFilter?: IEventFilter;
    managedEvent?: IManagedEvent;
    managedEventLoading?: boolean;
    managedEventError?: any;
    updatingEvent?: boolean;
    creatingDiscountCode?: boolean;
}

export type TLinkedEventType = 'Festival' | 'Contest' | 'Event';

export interface IManagedEventResponse {
    status: string;
    data: IManagedEvent;
}

export interface IManagedEvent {
    event?: IEvent;
    sales?: IManagedEventSales;
    tickets?: IManagedEventTickets;
    event_discounts?: IManagedEventDiscount;
    total_attendees?: number;
}

export interface IManagedEventTickets {
    total: number;
    data: IManagedEventTicket[];
    pagination: {
        currentPage: number;
        pageSize: number;
        totalPages: number;
        totalCount: number;
    };
}

export interface IManagedEventSales {
    total: {
        amount: number;
        usd_amount: number;
        formatted_amount: string;
        count: number;
    };
    ticket_types: Record<string, any>;
    data: IManagedEvenetResponseData[];
    pagination: {
        currentPage: number;
        pageSize: number;
        totalPages: number;
        totalCount: number;
    };
}

export interface IManagedEventDiscount {
    total: number;
    data: IManagedEventDiscountCode[];
}

export interface ICreateEvent
    extends Pick<Partial<IPostFormInitialState>, 'scheduled_published_date' | 'publishStatus' | 'status'> {
    name?: string;
    description?: string;
    event_start_date?: string;
    event_end_date?: string;
    linked_event?: string;
    kind?: IEventKind;
    tags?: string[];
    linked_event_type?: TLinkedEventType;
    location?: ILocation;
    with_fee?: boolean;
    fee_structure?: FeeStructure[];
    feature_image?: string;
    temp_feature_image?: string;
    state?: IEventState;
}

export interface IGetEvents {
    page?: number;
    limit?: number;
    params?: string;
}

export interface IGetEventDetails {
    slug: string;
    params?: string;
}

export interface IGetSimilarEvents extends Pagination {
    kind?: string;
    tags?: string;
}

export type FilterLocation = {
    address: string;
    coordinates: {
        lat: number;
        lng: number;
    };
};

export type TEventFilter =
    | 'kind'
    | 'age_restriction'
    | 'location'
    | 'with_fee'
    | 'event_start_date'
    | 'event_end_date'
    | 'page'
    | 'limit';

export type IEventFilter = {
    [key in TEventFilter]: {
        value: string | string[] | number | FilterLocation;
        displayValue: string[] | string;
    };
};

export type IFilterEvents = {
    [key in TEventFilter]?: string[] | string | number;
};

export interface IUpdateEvent {
    id: string;
    body: ICreateEvent;
    fromCreate?: boolean;
}

interface AuthenticatedPurchaseTicket {
    linked_event: string;
    linked_event_type: TLinkedEventType;
    category: 'tickets' | 'submissions' | 'donations';
    items: ICheckoutItem[];
    name: string;
    is_authenticated: true;
    email: string;
    phone?: string;
}

interface GuestPurchaseTicket {
    linked_event: string;
    linked_event_type: TLinkedEventType;
    category: 'tickets' | 'submissions' | 'donations';
    items: ICheckoutItem[];
    name: string;
    is_authenticated?: false | undefined;
    email: string;
    phone: string;
}

export type IPurchaseTicket = AuthenticatedPurchaseTicket | GuestPurchaseTicket;

export interface IGetManageEvent {
    eventId: string;
    salePage?: number;
    saleLimit?: number;
    ticketPage?: number;
    ticketLimit?: number;
    searchTerm?: string;
    startDate?: string;
    endDate?: string;
    ticketType?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface IManagedEvenetResponseData {
    _id: string;
    category: string;
    items: Item[];
    name_used: string;
    original_currency: string;
    transaction_currency: string;
    price: number;
    linked_event: string;
    linked_event_type: string;
    email_used: string;
    completed: boolean;
    refunded: boolean;
    location: Location;
    deleted: boolean;
    billing_address: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    invoice: Invoice;
    is_discounted: boolean;
    discount: any;
    usd_price: number;
    usd_discounted_price: number;
    formatted_price: string;
    formatted_usd_price: string;
    formatted_discounted_price: string;
    formatted_usd_discounted_price: string;
    exchange_rate?: number;
}

export interface Item {
    id: string;
    title: string;
    description: string;
    original_price: number;
    price: number;
    currency: string;
    quantity: number;
    image: string;
    details: Detail[];
}

export interface Detail {
    label: string;
    value: string;
}

export interface Location {
    coordinates: number[];
    type: string;
}

export interface Invoice {
    amount: number;
    amount_captured: number;
    currency: string;
    formatted_amount: string;
    formatted_amount_captured: string;
}

export interface IManagedEventTicket {
    _id: string;
    ticket_id: string;
    recipient_email: string;
    checked_in: boolean;
    seat_info: string;
    price: number;
    usd_price: number;
    formatted_price: string;
    formatted_usd_price: string;
    ticket_type: string;
}

export interface IManagedEventDiscountCode {
    _id: string;
    code: string;
    expiration_date: string;
    code_type: string;
    discount_type: string;
    discount: number;
    event: string;
    used: boolean;
    discount_structure: string;
    deleted: boolean;
    created_by: string;
    createdAt: string;
    updatedAt: string;
    count: number;
    active: boolean;
    __v: number;
}

export type DiscountCodeBase = {
    expiration_date: string;
    discount_type: 'percentage' | 'fixed';
    discount: number;
    discount_structure?: 'one_time' | 'time_period';
    active: boolean;
};

export type TCodeType = 'discount' | 'coupon' | 'reedemable';
export type EventDiscount = DiscountCodeBase & {
    code_type: TCodeType;
    event: string;
    contest?: never;
    audition?: never;
};

export type ContestDiscount = DiscountCodeBase & {
    code_type: 'reedemable' | 'discount';
    contest?: string;
    event?: never;
    audition?: never;
};

export type AuditionDiscount = DiscountCodeBase & {
    code_type: 'coupon';
    audition: string;
    event?: never;
    contest?: never;
};

export type ICreateDiscountCode = EventDiscount | ContestDiscount | AuditionDiscount;

export interface IUpdateDiscount {
    id: string;
    body: ICreateDiscountCode;
}

export interface ICancelEvent {
    eventId: string;
}
